module.exports = __webpack_public_path__ + "band_11_son.3f10a52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_11_son.png
// module id = givU
// module chunks = 0